import { useState } from "react";

export const useCreateAction = () => {
  const [showCreateDropdown, setShowCreateDropdown] = useState(false);

  const toggleDropdown = () => setShowCreateDropdown(prev => !prev);

  const handleGalleryClick = () => {
    setShowCreateDropdown(false);
  };

  const handleFolderClick = () => {
    setShowCreateDropdown(false);
  };

  return {
    showCreateDropdown,
    setShowCreateDropdown,
    toggleDropdown,
    handleGalleryClick,
    handleFolderClick
  };
};
